// import Notify from "vue-notifyjs";
import SideBar from "@/components/shared/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import "es6-promise/auto";

//css assets
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/sass/paper-dashboard.scss";
import "@/assets/css/themify-icons.css";

export default {
  install(app) {
    app.use(GlobalComponents);
    app.use(GlobalDirectives);
    app.use(SideBar);
    // Désactivé pour éviter l'erreur "notificationStore undefined" dans certains builds
    // Vous pouvez réactiver si nécessaire:
    // app.use(Notify);
  },
};
